
/**
 * ⏳ Calcule la distance temporelle entre deux dates
 * @returns {Object} Informations détaillées sur le temps restant
 */
global.dateDist = function(date, dateStart) {
    if (date) {
        const end = new Date(date);
        const start = new Date(dateStart);

        const _centieme = 10;
        const _second = 1000;
        const _minute = _second * 60;
        const _hour = _minute * 60;
        const _day = _hour * 24;
        let timer;
        const now = new Date();
        const nowNb = now;
        // const nowNb = now - this.timeServerDiff;
        const distance = end - nowNb;

        const days = Math.floor(distance / _day);
        const hours = Math.floor((distance % _day) / _hour);
        const minutes = Math.floor((distance % _hour) / _minute);
        const seconds = Math.floor((distance % _minute) / _second);
        const centiemes = Math.floor((distance % _second) / _centieme);

        const n = (n) => {
            return n > 9 ? "" + n : "0" + n;
        };

        let short = ' ';
        if (days > 0) short += days + ' jour' + (days > 1 ? 's' : '') + ' ';
        if (days > 0 || hours > 0) short += hours + ' h ';
        if (days > 0 || hours > 0 || minutes > 0) short += n(minutes) + ' min ';
        short += n(seconds) + ' sec';

        let long = ' ';
        if (days > 0) long += days + ' jour' + (days > 1 ? 's' : '') + ' ';
        if (days > 0 || hours > 0) long += hours + ' heure' + (hours > 1 ? 's' : '') + ' ';
        if (days > 0 || hours > 0 || minutes > 0) long += n(minutes) + ' minute' + (minutes > 1 ? 's' : '') + ' ';
        long += n(seconds) + ' seconde' + (seconds > 1 ? 's' : '');

        let launchMsg = '\nDébute dans\n' + short;

        if (end.getDate() === now.getDate() && end.getMonth() === now.getMonth() && end.getYear() === now.getYear()) {
            launchMsg = launchMsg + '\n(à ' + end.getHours() + ' h ' + pad(end.getMinutes(), 2) + ')';
        } else if (end.getDate() - 1 === now.getDate() && end.getMonth() === now.getMonth() && end.getYear() === now.getYear()) {
            launchMsg = launchMsg + '\n(Demain à ' + end.getHours() + ' h ' + pad(end.getMinutes(), 2) + ')';
        }

        if (distance < 0) {
            short = '-';
            long = '-';
            launchMsg = '\n\nEn cours';
            for (let i = 0; i < (Math.floor(nowNb / _second) % 4); i++) {
                launchMsg += '.';
            }
        }

        let percent = (nowNb - start) * 100 / (end - start);
        if (percent < 0) percent = 0;
        if (percent > 100) percent = 100;

        return {
            "distance": distance,
            "days": days,
            "hours": hours,
            "minutes": minutes,
            "seconds": seconds,
            "centiemes": centiemes,
            "short": short,
            "launchMsg": launchMsg,
            "long": long,
            "percent": percent
        };
    } else {
        return {
            "distance": 0,
            "days": 0,
            "hours": 0,
            "minutes": 0,
            "seconds": 0,
            "centiemes": 0,
            "short": '-',
            "long": '-',
            "percent": 0
        };
    }
}

